
import React                         from 'react';
import {Route, IndexRoute} from 'react-router';
import App                           from 'components/App';
import MaintenancePage                 from 'components/maintenancePage'

export default (
    <Route path="/" component={App}>
        <IndexRoute component={MaintenancePage} title={'Worthy'} />
        <Route path="*" component={MaintenancePage} title={'Worthy'} />
    </Route>
);
